import { Route } from '@angular/router';

export const BreedRoutes: Route[] = [
  {
    path: 'breed',
    loadComponent: () => import('../pages/breed/breed.page'),
  },
];
